<div fxLayout="row" fxLayoutAlign="start ">
  <div fxFlex="1 0 auto">
    <h1>Organisations</h1>
  </div>
  <div fxFlex="0 0 auto" class="actions">
    <a mat-flat-button color="primary" [routerLink]="['new']"
      >New Organisation</a
    >
  </div>
</div>
<bar-loader [loading]="loading$ | async"></bar-loader>

<div class="filters">
  <mat-radio-group [formControl]="filterControl" (change)="updateFilter()">
    <mat-radio-button value="enabled">Enabled</mat-radio-button>
    <mat-radio-button value="all">All</mat-radio-button>
  </mat-radio-group>
</div>

<organisations-table [organisations]="organisations"></organisations-table>
